
import dealerTisk from '@/components/dealer/head/dealerTisk.vue'
import dealerModule from '@/components/dealer/head/dealerModule.vue'
import Scorenum from '~/components/common/Scorenum.vue'
import Label from '~/components/common/Label.vue'
export default {
  components: {
    'dealer-tisk': dealerTisk,
    'dealer-module': dealerModule,
    Scorenum,
    Label
  },
  provide() {
    return {
      main: null
    }
  },
  inject: ['tips'],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      state: this.$store.state.riskcontrol['311001'], // 1：官网 查看详情  2：详情 跳转官网  3：查看详情
      iframeurl: '',
      tipstype: '',
      ourl: '',
      urltype: 'webUrl',
      moduleShow: false,
      iframeshow: false
    }
  },
  computed: {
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    linklist(item) {
      if (this.state == 2 || (this.state != 1 && this.state != 2 && this.state != 3)) this.linkand(item)
      else this.listdetail(item)
    },
    listdetail(item) {
      // 查看详情
      this.datastatistics('20', item.website, item.traderCode)
      window.open(`/${this.$store.state.LanguageCode}/dealer/${item.traderCode}.html`, '_blank', 'noopener,noreferrer')
    },
    async linkand(item) {
      // 跳转官网
      if (this.$store.state.riskcontrol['91017'] == '2') return
      const tt = item.website
      console.log(tt, 3333)
      // if (!item.isLegal) return
      try {
        window.gtag('event', 'click', {
          event_category: 'click',
          event_label: 'click website'
        })
      } catch (err) {}
      this.ourl = tt
      // await this.$emit('tjopenUlr', tt, '21', item.traderCode)
      const that = this
      await this.datastatistics('21', tt, item.traderCode, function (res) {
        console.log(res, 123)
        const u = res.url && res.url.includes('http') ? res.url : `https://${res.url}`
        that.iframeval(u)
        that.tipstype = String(res.type)
      })
      if (this.tips && this.tips.title) {
        setTimeout(() => {
          this.urltype = 'sites'
          this.moduleShow = true
          this.$nextTick(() => {
            this.$refs.tisk.open()
          })
        }, 1000)
      } else {
        this.$nextTick(() => {
          if (this.tipstype == '0') {
            this.iframeshow = true
          } else {
            const a = document.createElement('a')
            a.setAttribute('href', tt)
            a.setAttribute('target', '_blank')
            a.setAttribute('id', 'startTelMedicine')
            // 防止反复添加
            if (document.getElementById('startTelMedicine')) {
              document.body.removeChild(document.getElementById('startTelMedicine'))
            }
            document.body.appendChild(a)
            a.click()
          }
        })
      }
    },
    iframeval(val) {
      // iframe复制
      console.log(val, 3331)
      this.iframeurl = val
    },
    iframeif(bool) {
      // iframe显示状态
      this.iframeshow = bool
    },
    close() {
      // 关闭弹框
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.$refs.tisk && this.$refs.tisk.close()
      })
    }
  }
}
